module.exports = __webpack_public_path__ + "build/img/spring3.9f91cfef.png";